<script lang="ts">
  import Skeleton from '$lib/components/ui/Skeleton.svelte'
</script>

<Skeleton>
  <div class="wrapper">
    <div class="icon"></div>
    <div class="card"></div>
  </div>
</Skeleton>

<style lang="postcss">
  .wrapper {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    height: 2.25rem;
  }
  .card,
  .icon {
    border-radius: var(--radius-full);
  }
  .card {
    width: 7rem;
    height: 100%;
  }
  .icon {
    aspect-ratio: 1;
    height: 70%;
  }
</style>
